<template>
  <td class="table-status-cell" :class="status">
    <div class="pill" v-if="status">{{ status }}</div>
  </td>
</template>
<script>
import TableCellMixin from "./TableCellMixin.js";

export default {
  mixins: [TableCellMixin],
  computed: {
    status() {
      return String(this.value || "").toLowerCase();
    },
  },
};
</script>
<style scoped lang="scss">
td {
  text-align: center;

  .pill {
    border-radius: 3em;
    padding: 0.3em 0.6em;
    display: block;
    text-transform: uppercase;
    font-weight: 500;
    letter-spacing: 0.05em;
    font-size: 0.7em;
    background: color-mix(in lab, currentColor 10%, transparent);
    color: color-mix(in lab, currentColor, transparent);
    border: 1px solid;
  }

  &.live,
  &.ready,
  &.success,
  &.paid,
  &.active {
    .pill {
      background: #e0f3bf;
      color: #569e2f;

      @media (prefers-color-scheme: dark) {
        background: none;
      }
    }
  }

  &.sandbox,
  &.pending,
  &.scheduled,
  &.cancelling {
    .pill {
      background: #fbecbb;
      color: #d17a0e;

      @media (prefers-color-scheme: dark) {
        background: none;
      }
    }
  }

  &.error,
  &.unpaid,
  &.failed {
    .pill {
      background: #ffdddd;
      color: #b14e4e;

      @media (prefers-color-scheme: dark) {
        background: none;
      }
    }
  }
}
</style>
